import axios from "axios";
import { API_END_POINT } from "../../../constants/api";
import { returnErrors, clearErrors } from "../errorAction";
export const SEND_YARN = "SEND_YARN";
export const GET_SEND_YARN = "GET_SEND_YARN";
export const SEND_YARN_SUCCESS = "SEND_YARN_SUCCESS";
export const SEND_YARN_FAIL = "SEND_YARN_FAIL";

export function sendYarnAction(params) {
  return (dispatch) => {
    const data = {
      ...params,
      date_send_yarn: params.date_send_yarn.format("YYYY-MM-DD"),
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${params.token}`,
      },
    };

    const body = JSON.stringify(data);

    axios
      .post(
        `${API_END_POINT}/api/sizer/yarn/send-yarn/register`,
        body,
        config
      )
      .then((res) =>
        dispatch({
          type: SEND_YARN,
          payload: res.data,
        })
      )
      .then((data) =>
        dispatch(
          clearErrors("Yarn Send Successfully", 201, "SEND_YARN_SUCCESS")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(err.response.data, err.response.status, "SEND_YARN_FAIL")
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function getSendYarn(company_id, sizerId, token) {
  console.log("params", token);
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    // const body = JSON.stringify(params);

    axios
      .get(
        `${API_END_POINT}/api/sizer/yarn/send-yarn/get/${sizerId}/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: GET_SEND_YARN,
          payload: res.data,
        })
      )

      .catch((err) => console.log("Error", err));
  };
}
